import React from "react";
import "../../styles/holidays/festive.scss";

export function FestiveText({ className = "", ...rest }) {
    return <span {...rest} className={`festive ${className}`} />;
}